import React from 'react'
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom'
import { observer, inject } from 'mobx-react'
import { toJS } from 'mobx'

import Notfound from '../../screens/not_found'

import './index.scss'

import Header from '../../components/global/header'
import Dashboard from '../../screens/dashboard'
import Administrators from '../../screens/administrators'
import AdministratorsEdit from '../../screens/administrators/edit'
import ClientsList from '../../screens/clients/list'
import ClientDetail from '../../screens/clients/detail'
import Categories from '../../screens/categories'
import ProductsList from '../../screens/products/list'
import ProductDetail from '../../screens/products/detail'
import ProductEdit from '../../screens/products/edit'
import ShoppingCart from '../../screens/products/shoppingCart'
import Tags from '../../screens/tags'
import Delivery from '../../screens/delivery'
import Payments from '../../screens/payments'
import Privileges from '../../screens/privileges'
import Templates from '../../screens/templates'
import TemplatesCreateEdit from '../../screens/templates/createEdit'
import StaticPages from '../../screens/static_pages'
import StaticPageCreateEdit from '../../screens/static_pages/createEdit'
import Static from '../../screens/static'
import Settings from '../../screens/settings'
import Parameters from '../../screens/parameters/Parameters'
import Menu from '../../screens/menu/Menu'
import TopProducts from '../../screens/topProducts/TopProducts'
import FixedSets from '../../screens/fixedSets/FixedSets'
import Banner from '../../screens/banner/Banner'
import Article from '../../screens/menu/article/Article'
import DynamicSets from '../../screens/dynamicSets/DynamicSets'
import Customers from '../../screens/Customers/Customers'
import CustomersOrders from '../../screens/CustomersOrders/CustomersOrders'
import Gifts from '../../screens/gifts/Gifts'
import Shops from '../../screens/shops/list/Shops'
import ShopDetails from '../../screens/shops/detail'
import CustomerOrderStatuses from '../../screens/CustomerOrderStatuses/CustomerOrderStatuses'
import CustomerOrderStatusesModify from '../../screens/CustomerOrderStatuses/CustomerOrderStatusesModify/CustomerOrderStatusesModify'
import ExampleTable from '../../screens/ExpaleTable/ExampleTable'
import Coupons from '../../screens/Coupons/Coupons'
import Vignettes from '../../screens/Vignettes/Vignettes'
import MonitoredShops from '../../screens/MonitoredShops/MonitoredShops'

import Test from '../../screens/test/Test'

// import DemoComponent from '../../screens/demo';

import { api } from '../../functions/api'
import XmlExports from '../../screens/XmlExports/XmlExports'
import ServiceProtocol from '../../screens/serviceProtocol/ServiceProtocol'
import ServiceProtocols from '../../screens/ServiceProtocols/ServiceProtocols'
import ContractWithdrawals from '../../screens/ContractWithdrawals/ContractWithdrawals'
import IssueCards from '../../screens/IssueCards/IssueCards'
import IssueCardDetail from '../../screens/IssueCards/detail'
import ToStorage from '../../screens/toStorage'
import ProductShopsManagement from '../../screens/ProductShopsManagement/ProductShopsManagement'

@inject('internal')
@inject('translate')
@observer
export default class MainRouteComponents extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            isDrawerOpen: false
        }
    }
    componentDidMount() {
        // let isAdmin = toJS(this.props.internal.user.data.role.id) !== 2 ? true : false //nacitanie shooping cartu iba ak niesi admin
        // if(isAdmin){
        //   this.getShoppingCart()
        // }
        window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true
        this.loadStaticPages()
    }

    loadStaticPages = async () => {
        let load_data = await api({
            method: 'GET',
            url: `pages`,
            authorization: this.props.internal.user.access_token
        })

        if (load_data.success === true) {
            this.props.internal.setStaticPages(load_data.data.data)
        }
    }

    getShoppingCart = async () => {
        let load_data = await api({
            method: 'get',
            url: 'shopping-cart',
            authorization: this.props.internal.user.access_token
        })

        if (load_data.success === true) {
            this.props.internal.addToShoppingCart(load_data.data.data.items)
            this.props.internal.updateNumberOfItemsInShopingCart(load_data.data.data.items_count)
        }
    }

    checkDrawer = data => {
        this.setState({ isDrawerOpen: data })
    }

    rerender = true

    render() {
        window.__MUI_USE_NEXT_TYPOGRAPHY_VARIANTS__ = true
        let isAdmin

        const { user } = toJS(this.props.internal)

        if (user) {
            if (user.data) {
                if (user.data.role && user.data.role.id) {
                    isAdmin = user.data.role.id === 2 || user.data.role.id === 5 //nacitanie shopping cartu iba ak niesi admin/obchodny zastupca
                    if (!isAdmin && this.rerender) {
                        this.rerender = false
                        this.getShoppingCart()
                    }
                }
            }
        }

        return (
            <Router>
                <div className={'logged'}>
                    <Header open={this.checkDrawer} />
                    {/* <div style={{overflow: "auto"}} > */}
                    {/* <div className={this.state.isDrawerOpen ? 'drawerOpen' : 'drawerClose'}> */}
                    <div className={this.state.isDrawerOpen ? 'drawerClose' : 'drawerClose'}>
                        <Switch>
                            <Route exact path='/' component={Dashboard} />
                            <Route exact path='/administrators' component={Administrators} />
                            <Route
                                exact
                                path='/administrators/:idAdmin/edit/tab=:tabIndex'
                                component={AdministratorsEdit}
                            />
                            <Route exact path='/clients' component={ClientsList} />
                            <Route
                                exact
                                path='/clients/:idClient/:tabName'
                                component={ClientDetail}
                            />
                            <Route
                                exact
                                path='/clients/:idClient/:tabName/:id'
                                component={ClientDetail}
                            />
                            {/* <Route exact path="/clients/searchterm=:searchterm" component={ClientsList} /> */}
                            {/* <Route exact path="/clients/search=:searchterm/page[size]=:per_page/page[number]=:page_number/:by=:dir" component={ClientsList} /> */}
                            {/* <Route exact path="/clients/searchterm=:searchterm/page_size=:per_page/page_number=:page_number/by=:by/dir=:dir" component={ClientsList} /> */}
                            <Route
                                exact
                                path='/clients/:idClient/detail/tab=:tabIndex'
                                component={ClientDetail}
                            />
                            {/* <Route exact path="/clients/:idClient/detail/tab=:tabIndex/searchterm=:searchterm/page_size=:per_page/page_number=:page_number/by=:by/dir=:dir" component={ClientDetail} />  */}
                            <Route exact path='/products' component={ProductsList} />
                            <Route
                                exact
                                path='/products/:idProduct/detail'
                                component={ProductDetail}
                            />
                            {/* <Route exact path="/products/:idProduct/detail/:config" component={ProductDetail} /> */}
                            <Route
                                exact
                                path='/products/:idProduct/edit/tab=:tabIndex'
                                component={ProductEdit}
                            />
                            <Route exact path='/products' component={ProductsList} />
                            <Route path='/categories' component={Categories} />
                            <Route path='/tags' component={Tags} />
                            <Route path='/transports' component={Delivery} />
                            <Route path='/payments' component={Payments} />
                            {/* <Route  path="/contact" component={DemoComponent} />
                    <Route  path="/terms_of_use" component={DemoComponent} /> */}
                            <Route exact path='/static/:page' component={Static} /> */}
                            <Route path='/shoppingCart' component={ShoppingCart} />
                            <Route exact path='/templates' component={Templates} />
                            <Route
                                exact
                                path='/templates/:action'
                                component={TemplatesCreateEdit}
                            />
                            <Route
                                exact
                                path='/templates/:id/edit'
                                component={TemplatesCreateEdit}
                            />
                            <Route path='/privileges/:tabName' component={Privileges} />
                            <Route exact path='/static_pages' component={StaticPages} />
                            <Route
                                exact
                                path='/static_pages/:action'
                                component={StaticPageCreateEdit}
                            />
                            <Route
                                exact
                                path='/static_pages/:id/edit'
                                component={StaticPageCreateEdit}
                            />
                            <Route exact path='/vignettes' component={Vignettes} />
                            <Route exact path='/monitored-shops' component={MonitoredShops} />
                            <Route exact path='/monitored-product-shops' component={ProductShopsManagement} />
                            <Route exact path='/xml-exports' component={XmlExports} />
                            <Route exact path='/coupons' component={Coupons} />

                            <Route path='/settings/:tabName' component={Settings} />
                            <Route exact path='/parameters' component={Parameters} />
                            <Route exact path='/:idShop/menu' component={Menu} />
                            <Route exact path='/:idShop/menu/article/:id' component={Article} />
                            <Route exact path='/:idShop/top-products' component={TopProducts} />
                            <Route exact path='/:idShop/fixed-sets' component={FixedSets} />
                            <Route exact path='/:idShop/banner' component={Banner} />
                            <Route exact path='/:idShop/dynamic-sets' component={DynamicSets} />
                            <Route exact path='/customers' component={Customers} />
                            <Route
                                exact
                                path='/:idShop/customers-orders'
                                component={CustomersOrders}
                            />
                            <Route
                                exact
                                path='/:idShop/contract-withdrawals'
                                component={ContractWithdrawals}
                            />
                            <Route exact path='/:idShop/gifts' component={Gifts} />
                            <Route exact path='/shops' component={Shops} />
                            <Route exact path='/shops/:id/:tabName' component={ShopDetails} />
                            <Route
                                exact
                                path='/customer-order-statuses'
                                component={CustomerOrderStatuses}
                            />
                            <Route
                                exact
                                path='/customer-order-statuses/new'
                                component={CustomerOrderStatusesModify}
                            />
                            <Route
                                exact
                                path='/customer-order-statuses/:id/edit'
                                component={CustomerOrderStatusesModify}
                            />
                            <Route exact path='/service-protocol' component={ServiceProtocol} />
                            <Route exact path='/service-protocols' component={ServiceProtocols} />
                            <Route exact path='/issue-cards' component={IssueCards} />
                            <Route exact path='/issue-cards/:id/:tab' component={IssueCardDetail} />
                            <Route exact path='/to-storage' component={ToStorage} />

                            <Route exact path='/testtable' component={ExampleTable} />
                            <Route exact path='/test/:tabName' component={Test} />
                            <Route path='*' component={Notfound} />
                        </Switch>
                    </div>
                    {/* </div> */}
                </div>
            </Router>
        )
    }
}



// WEBPACK FOOTER //
// ./src/routes/logged/index.js